<template>
  <v-card elevation-0>
    <v-card-title class="ml-5 mr-5 pa-5" >
      <v-icon color="grey darken-2">mdi-map-marker</v-icon>

      <div class="subtitle-1 font-weight-medium pl-2">Site Address:</div>

      <div class="subtitle-1 pl-2">{{ site.address }}</div>
    </v-card-title>

    <v-row class="ml-5 mr-5 pa-5">
      <v-btn rounded color="primary" class="ma-2" @click="addBuilding" :disabled="disabled">
        <v-icon class="pr-2">mdi-plus-circle</v-icon>
        Add a Building to this Site
      </v-btn>

    </v-row>

    <template v-for="(building, index) in site.buildings"  >
      <Building :site="site" :building="building" v-bind:key="building.id" ></Building>
    </template>
  </v-card>
</template>

<script>
import { router } from "../router";
import Building from "./Building.vue";

export default {
  name: "Add",
  components: {
    Building
  },
  props: ["site"],
  data: () => ({
    disabled: false
  }),
  computed: {
    buildings: function () {
      return this.site.buildings;
    }
  },
  mounted() {
    if (this.site.inspection_status.toString() !== "P" ){
      this.disabled = true;
    }
  },
  methods: {
    addBuilding(){
      //TODO: use the building service here to save the building?
      const siteId = this.site.id;
      this.$store.dispatch("sites/addBuilding", { site: siteId} );


    },
    input: function() {
      this.changed = true;
    },
    validate() {
      if (this.$refs.form.validate()) {
      }
    },
    save() {

    }
  }
};
</script>
